// Common international dialing codes with flags. India first (default).
export const countryCodes = [
  { name: "India", code: "+91", flag: "🇮🇳" },
  { name: "United States", code: "+1", flag: "🇺🇸" },
  { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
  { name: "United Arab Emirates", code: "+971", flag: "🇦🇪" },
  { name: "Australia", code: "+61", flag: "🇦🇺" },
  { name: "Canada", code: "+1", flag: "🇨🇦" },
  { name: "Singapore", code: "+65", flag: "🇸🇬" },
  { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
  { name: "Qatar", code: "+974", flag: "🇶🇦" },
  { name: "Kuwait", code: "+965", flag: "🇰🇼" },
  { name: "Oman", code: "+968", flag: "🇴🇲" },
  { name: "Bahrain", code: "+973", flag: "🇧🇭" },
  { name: "Nepal", code: "+977", flag: "🇳🇵" },
  { name: "Sri Lanka", code: "+94", flag: "🇱🇰" },
  { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
  { name: "Pakistan", code: "+92", flag: "🇵🇰" },
  { name: "Bhutan", code: "+975", flag: "🇧🇹" },
  { name: "Maldives", code: "+960", flag: "🇲🇻" },
  { name: "Malaysia", code: "+60", flag: "🇲🇾" },
  { name: "Thailand", code: "+66", flag: "🇹🇭" },
  { name: "Indonesia", code: "+62", flag: "🇮🇩" },
  { name: "Philippines", code: "+63", flag: "🇵🇭" },
  { name: "Vietnam", code: "+84", flag: "🇻🇳" },
  { name: "China", code: "+86", flag: "🇨🇳" },
  { name: "Hong Kong", code: "+852", flag: "🇭🇰" },
  { name: "Japan", code: "+81", flag: "🇯🇵" },
  { name: "South Korea", code: "+82", flag: "🇰🇷" },
  { name: "Germany", code: "+49", flag: "🇩🇪" },
  { name: "France", code: "+33", flag: "🇫🇷" },
  { name: "Italy", code: "+39", flag: "🇮🇹" },
  { name: "Spain", code: "+34", flag: "🇪🇸" },
  { name: "Netherlands", code: "+31", flag: "🇳🇱" },
  { name: "Switzerland", code: "+41", flag: "🇨🇭" },
  { name: "Ireland", code: "+353", flag: "🇮🇪" },
  { name: "Portugal", code: "+351", flag: "🇵🇹" },
  { name: "Belgium", code: "+32", flag: "🇧🇪" },
  { name: "Sweden", code: "+46", flag: "🇸🇪" },
  { name: "Norway", code: "+47", flag: "🇳🇴" },
  { name: "Denmark", code: "+45", flag: "🇩🇰" },
  { name: "Russia", code: "+7", flag: "🇷🇺" },
  { name: "Turkey", code: "+90", flag: "🇹🇷" },
  { name: "South Africa", code: "+27", flag: "🇿🇦" },
  { name: "Egypt", code: "+20", flag: "🇪🇬" },
  { name: "Nigeria", code: "+234", flag: "🇳🇬" },
  { name: "Kenya", code: "+254", flag: "🇰🇪" },
  { name: "Brazil", code: "+55", flag: "🇧🇷" },
  { name: "Mexico", code: "+52", flag: "🇲🇽" },
  { name: "Argentina", code: "+54", flag: "🇦🇷" },
  { name: "New Zealand", code: "+64", flag: "🇳🇿" },
  { name: "Mauritius", code: "+230", flag: "🇲🇺" },
];

export const defaultCountry = countryCodes[0];
